import { CloudDownload, Plus } from '@tamagui/lucide-icons';
import { FloatingButton } from '@unistocks/components/button/floating-action-button';
import { Page } from '@unistocks/components/page/page';
import { ExternalAccountsList } from '@unistocks/features/external-accounts/components/external-accounts-list';
import { ExternalAccountsHeaderRight } from '@unistocks/features/external-accounts/header/header-right';
import { useHistoryBreadcrumb } from '@unistocks/features/navigation/use-history-breadcrumb';
import { t } from '@unistocks/localization';
import {
  externalAccountsGetAccountsQueryKey,
  useExternalAccountsGetAccountsQuery
} from '@unistocks/proxy/axios-client/ExternalAccountsQuery';
import { Link } from 'expo-router';

export function ExternalAccounts() {
  const {
    data: externalAccounts,
    isSuccess,
    isRefetching,
    refetch
  } = useExternalAccountsGetAccountsQuery();
  const breadcrumbs = useHistoryBreadcrumb();

  return (
    <Page size={'small'}>
      <Page.ScrollView
        headerLogo={false}
        headerTitle={t('::ExternalAccounts')}
        headerIcon={<ExternalAccountsHeaderRight />}
        breadcrumbs={breadcrumbs}
        refreshing={isRefetching}
        onRefresh={refetch}
        queryState={{
          queryKeys: [externalAccountsGetAccountsQueryKey()],
          loadingText: t('::Import:BankAccount:LoadingAccounts'),
          isEmpty: isSuccess && !externalAccounts.items.length,
          noDataIcon: CloudDownload,
          noDataText: t('::ExternalAccounts:Description1')
        }}
      >
        {isSuccess ? (
          <Page.Content p={0}>
            <ExternalAccountsList externalAccounts={externalAccounts.items} />
          </Page.Content>
        ) : null}
      </Page.ScrollView>

      <Link asChild href={'/(tabs)/(menu)/external-accounts/add-account'}>
        <FloatingButton Icon={Plus} />
      </Link>
    </Page>
  );
}
